import React,{useState} from 'react'
import { Sidebar } from '../components/Layout/Sidebar'
import Topbar from '../components/Layout/Topbar'
// Supabase auth + DB
import { signUp, saveUserProfile } from '../supabase.config'
import { useNavigate } from 'react-router-dom'
import StaffForm from '../CreateUser/StaffForm'
const CreateStaff = () => {
    const navigate = useNavigate("")
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
   const [role, setRole] = useState("")
    const [contact, setContact] = useState("")
 
    const handleCreateUser = async () =>{
      try {
        if (!email || !password || !name || !role) {
          alert('Please fill name, email, password and role')
          return
        }

        // 1) Create auth user in Supabase
        const { data, error } = await signUp(email, password, { name, role })
        if (error) {
          alert(`Failed to create user: ${error.message}`)
          return
        }
        const userId = data?.user?.id
        if (!userId) {
          alert('User created but no user id returned')
          return
        }

        // 2) Insert profile row into users table
        const profile = {
          name,
          email,
          contact,
          companyName: "",
          gstNo: "",
          gstDocument: "",
          agreement: "",
          otherDoc: "",
          insuranceType: "",
          companyAddress: "",
          role,
          partnerType: "",
          walletBalance: "",
          service: "logistics",
          rateList: null
        }

        const { error: profileError } = await saveUserProfile(userId, profile)
        if (profileError) {
          alert(`Failed to save staff profile: ${profileError.message}`)
          return
        }

        navigate("/users")
      } catch (err) {
        console.error(err)
        alert('Unexpected error creating staff: ' + err.message)
      }
    }
 
  return (
    <div className='flex bg-slate-100/80'>
    <Sidebar />
    <div className='flex h-[100vh] flex-1 flex-col overflow-y-scroll' >
    <Topbar />
      
        <StaffForm name={name} setName={setName}
   
        handleCreateUser={handleCreateUser}
        
        email={email} setEmail={setEmail}
        password={password} setPassword={setPassword}
        role={role} setRole={setRole}
        contact={contact} setContact={setContact}
         />
    </div>
</div>
  )
}

export default CreateStaff
